const STATUS = {
  coming_soon: { color: "#F5C518", label: "Coming Soon" },
  pre_order: { color: "#00C853", label: "Pre-Order Open" },
  live: { color: "#FFFFFF", label: "Live Now" },
  sold_out: { color: "#FF1744", label: "Sold Out" },
  archived: { color: "#757575", label: "Archived" },
  available: { color: "#00C853", label: "Core Collection" },
};

export const StatusBadge = ({ status, className = "" }) => {
  const s = STATUS[status] || STATUS.coming_soon;
  return (
    <div
      className={`inline-flex items-center gap-3 wc-label text-[11px] text-white ${className}`}
      data-testid={`status-badge-${status}`}
    >
      <span
        className="wc-dot-pulse inline-block w-2 h-2"
        style={{ background: s.color }}
      />
      <span>{s.label}</span>
    </div>
  );
};

export const statusActionLabel = (status) => {
  switch (status) {
    case "coming_soon":
      return "Join The Waitlist";
    case "pre_order":
      return "Pre-Order Now";
    case "live":
      return "Shop The Drop";
    case "sold_out":
      return "Sold Out";
    case "archived":
      return "View Archive";
    default:
      return "Learn More";
  }
};

export default StatusBadge;
